/**
 * atlas-cvp-enhancements.js
 * Small, additive companion script for the flavour-grid redesign (draft theme).
 * Does NOT modify atlas-product-custom-variant-picker.js — it layers one thing
 * on top of the existing swatch-table rows:
 *   Clicking anywhere on a row (not just the hidden .cvp-action button)
 *   selects that flavour, by delegating to the row's own .cvp-action button
 *   so all of the original script's selection logic still runs unchanged.
 */
(function () {
    function initRoot(root) {
        if (root.__cvpEnhanceBound) return;
        root.__cvpEnhanceBound = true;

        root.addEventListener('click', function (e) {
            // Let the original script's own listener handle real clicks on the action button.
            if (e.target.closest('.cvp-action')) return;

            var rowLabel = e.target.closest('label.atlas-cvp__table-row, label.atlas-cvp__table-main');
            if (!rowLabel) return;

            // Don't hijack clicks meant for other interactive controls inside a row
            // (quantity steppers, free-text messages on "swatch-table-text" steps).
            var excluded = e.target.closest('.js-cvp-inc, .js-cvp-dec, .atlas-cvp__textarea, .atlas-cvp__text-input');
            if (excluded) return;

            var row = rowLabel.closest('.atlas-cvp__table-row') || rowLabel;
            var rowBtn = row && row.querySelector('.cvp-action');
            if (rowBtn) {
                e.preventDefault();
                e.stopPropagation();
                rowBtn.click();
            }
        });
    }

    function scan() {
        var roots = document.querySelectorAll('.atlas-custom-variant-picker');
        for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
    }

    if (document.readyState !== 'loading') scan();
    else document.addEventListener('DOMContentLoaded', scan);

    // The picker can mount asynchronously; keep watching briefly in case scan()
    // ran before the container existed.
    var bodyMo = new MutationObserver(scan);
    bodyMo.observe(document.documentElement, { childList: true, subtree: true });
})();

/* ------------------------------------------------------------------
   Bluebells: loader for the "Design your own edible image" modal.
   Runs only on edible-image product pages and loads
   bluebells-edible-image.js (+ .css) from this same assets folder.

   Everything tweakable lives here:
     CAKE_PHOTO       the flat, straight-on cake shot used in the modal
     DEFAULT_SIZE     starting text size on the cake
     MAX_WORDS        how many words the message may contain
     MIN_DPI          warn below this print resolution on an A4 sheet
     VERSION          bump on every change so caches fetch the new files
------------------------------------------------------------------ */
(function () {
    /* One entry per edible-image product. photo = the flat, straight-on cake shot.
       panel = optional hand-measured printable icing panel, as fractions of the photo
       (x, y, w, h). Give it only when the automatic detection in
       bluebells-edible-image.js can't separate the panel from the piping - that
       happens when the two are close in colour, as on the mini slab. */
    /* Preset-artwork themes: the supplied picture already IS the A4 edible
       sheet, so there is no upload and no cake photo - the customer only adds
       their message on top of it. */
    function art(file) {
        return {
            artOnly: true,
            size: 40,
            photo: 'https://cdn.shopify.com/s/files/1/0884/4436/files/' + file
        };
    }
    var MINI_SLAB = {
        photo: 'https://cdn.shopify.com/s/files/1/0884/4436/files/mini-slab-edible-image-base-v1.jpg?v=1790628378',
        panel: { x: 0.1381, y: 0.1610, w: 0.7198, h: 0.6286 }
    };
    var PRODUCTS = {
        'edible-image-big-slab-cake': {
            photo: 'https://cdn.shopify.com/s/files/1/0884/4436/files/slab-cake-edible-image-base-v2.png?v=1790578480'
        },
        /* Round cakes: the printable area is a disc inside the rosette ring, not
           an A4 sheet. cx/cy/r are fractions of the photo width; printCm is the
           finished diameter of the edible image, saved at 300 dpi. */
        'edible-image-drizzle-cake': {
            photo: 'https://cdn.shopify.com/s/files/1/0884/4436/files/drizzle-cake-edible-image-base-v1.png?v=1790726385',
                        disc: { cx: 0.505, cy: 0.464, r: 0.298 },
            printCm: 20
        },
        'edible-image-mini-slab-cake': MINI_SLAB,

                /* Macarons and shortbread: same small-disc, photo-only treatment. */
        'edible-image-macarons-gf': {
            photo: 'https://cdn.shopify.com/s/files/1/0884/4436/files/macaron-edible-image-base-v1.png?v=1791063802',
            disc: { cx: 0.494, cy: 0.467, r: 0.267 },
            printCm: 4,
            noText: true,
            noun: 'macaron'
        },
        'edible-image-vanilla-shortbread-cookies': {
            photo: 'https://cdn.shopify.com/s/files/1/0884/4436/files/shortbread-edible-image-base-v1.png?v=1791063802',
            disc: { cx: 0.492, cy: 0.484, r: 0.281 },
            printCm: 5,
            noText: true,
            noun: 'cookie'
        },

        /* Cupcakes: a small fondant disc, photo only - there is no message step. */
        'edible-image-regular-cupcakes': {
            photo: 'https://cdn.shopify.com/s/files/1/0884/4436/files/regular-cupcake-edible-image-base-v2.png?v=1791053619',
            disc: { cx: 0.488, cy: 0.399, r: 0.291 },
            printCm: 5,
            noText: true,
            noun: 'cupcake'
        },
        'edible-image-mini-cupcakes': {
            photo: 'https://cdn.shopify.com/s/files/1/0884/4436/files/mini-cupcake-edible-image-base-v2.png?v=1791053619',
            disc: { cx: 0.484, cy: 0.436, r: 0.269 },
            printCm: 3.5,
            noText: true,
            noun: 'cupcake'
        },
        /* the same cake and the same A4 sheet, just sold as a kids theme */
        'kids-birthday-slab-cake-edible-image': MINI_SLAB,

        'kids-birthday-slab-cake-fairy': art('kids-slab-art-fairy.jpg?v=1790711397'),
        'kids-birthday-slab-cake-frozen': art('kids-slab-art-frozen.jpg?v=1790712876'),
        'kids-birthday-slab-cake-minecraft': art('kids-slab-art-minecraft.jpg?v=1790712876'),
        'kids-birthday-slab-cake-paw-patrol': art('kids-slab-art-paw-patrol.jpg?v=1790712876'),
        'kids-birthday-slab-cake-spider-man': art('kids-slab-art-spider-man.jpg?v=1790712876'),
        'kids-birthday-slab-cake-unicorn': art('kids-slab-art-unicorn.jpg?v=1790712876'),
        'kids-birthday-slab-cake-bluey': art('kids-slab-art-bluey.jpg?v=1790712876')
    };
    var DEFAULT_SIZE = 23;
    var MAX_WORDS = 4;
    var MIN_DPI = 150;
       var VERSION = '2026-10-04-72';


    var me = document.currentScript && document.currentScript.src;
    if (!me) {
        var all = document.querySelectorAll('script[src*="atlas-cvp-enhancements"]');
        me = all.length ? all[all.length - 1].src : '';
    }
    if (!me) return;

    function asset(name) {
        return me.replace(/atlas-cvp-enhancements\.js.*$/, name) + '?v=' + VERSION;
    }

    function start() {
        if (window.__bbEdibleImage) return;
        var product = null;
        for (var h in PRODUCTS) {
            if (!PRODUCTS.hasOwnProperty(h)) continue;
            if (location.pathname.indexOf('/products/' + h) !== -1) { product = PRODUCTS[h]; break; }
        }
        if (!product) return;
        window.__bbEdibleImage = {
            enabled: true,
            imageUrl: product.photo,
            panel: product.panel || null,
            disc: product.disc || null,
            printCm: product.printCm || 0,
            noText: !!product.noText,
            noun: product.noun || 'cake',
            artOnly: !!product.artOnly,
            defaultFontSize: product.size || DEFAULT_SIZE,
            maxWords: MAX_WORDS,
            minDpi: MIN_DPI,
            fontUrl: asset('lazydog-webfont.woff2'),
            cssUrl: asset('bluebells-edible-image.css')
        };
        var s = document.createElement('script');
        s.src = asset('bluebells-edible-image.js');
        document.head.appendChild(s);
    }

    /* ------------------------------------------------------------------
       Tick normaliser.

       The theme draws a completed step as a small green circle with a white
       check, followed by the label in the same green. Two other places draw a
       plain "checkmark label" text instead, so they look nothing like it.
       This finds those and rebuilds them with the same badge and text style.
    ------------------------------------------------------------------ */
    var TICK = '✓';

    function tickStyles() {
        if (document.getElementById('bb-tick-style')) return;
        var st = document.createElement('style');
        st.id = 'bb-tick-style';
        st.textContent =
            '.bb-tick{display:inline-flex;align-items:center;justify-content:center;' +
            'margin-right:10px;border-radius:50%;background:#2e7d32;width:16px;min-width:16px;' +
            'height:16px;color:#fff;font-weight:700;font-size:12px;line-height:1;' +
            'font-family:var(--font-poppins);-webkit-user-select:none;user-select:none;}' +
            '.bb-tick-label{color:#2e7d32;font-weight:500;font-size:14px;line-height:20px;' +
            'font-family:var(--font-poppins);}' +
            '.bb-tick-row{display:flex;align-items:center;}' +
            '.bb-tick-thumb{width:76px;height:auto;flex:0 0 76px;margin-right:10px;' +
            'border-radius:6px;border:1px solid rgba(38,41,103,.15);object-fit:cover;}' +
            '.bb-ei-tick{display:inline-flex;align-items:center;justify-content:center;' +
            'margin-right:10px;border-radius:50%;background:#2e7d32;width:16px;min-width:16px;' +
            'height:16px;color:#fff;font-weight:700;font-size:12px;line-height:1;' +
            'font-family:var(--font-poppins);flex:0 0 16px;}' +
            '.bb-ei-saved b,.bb-ei-summary b{color:#2e7d32;font-weight:500;font-size:14px;' +
            'line-height:20px;font-family:var(--font-poppins);}';
        document.head.appendChild(st);
    }

    /* The chosen add-on's picture lives on its row in the picker's own list.
       Match it by title so the summary can show the same thumbnail. */
    function thumbFor(label) {
        if (!label) return null;
        var rows = document.querySelectorAll('.atlas-cvp__ft-row');
        var best = null, bestLen = 0;
        for (var i = 0; i < rows.length; i++) {
            var titleEl = rows[i].querySelector('[class*="ft-title"]');
            var img = rows[i].querySelector('img');
            if (!titleEl || !img || !img.src) continue;
            var title = titleEl.textContent.replace(/\$[\d.,]+.*$/, '').trim();
            if (!title) continue;
            if (label.toLowerCase().indexOf(title.toLowerCase()) === 0 && title.length > bestLen) {
                best = img; bestLen = title.length;
            }
        }
        if (!best) return null;
        var t = document.createElement('img');
        t.className = 'bb-tick-thumb';
        t.src = best.src;
        t.alt = '';
        return t;
    }

    function normaliseTicks(root) {
        var picker = root || document.querySelector('.atlas-custom-variant-picker');
        if (!picker) return;
        var nodes = picker.querySelectorAll('*');
        for (var i = 0; i < nodes.length; i++) {
            var n = nodes[i];
            if (n.getAttribute('data-bb-tick') === '1') continue;
            if (n.className && String(n.className).indexOf('bb-tick') !== -1) continue;
            var first = n.firstChild;
            if (!first || first.nodeType !== 3) continue;
            var t = first.nodeValue;
            if (!t || t.charAt(0) !== TICK) continue;
            var label = t.slice(1).replace(/^\s+/, '');
            first.nodeValue = '';
            var badge = document.createElement('span');
            badge.className = 'bb-tick';
            badge.setAttribute('data-bb-tick', '1');
            badge.setAttribute('aria-hidden', 'true');
            badge.innerHTML = TICK_SVG;
            var text = document.createElement('span');
            text.className = 'bb-tick-label';
            text.textContent = label;
            n.insertBefore(text, first);
            n.insertBefore(badge, text);
            var thumb = thumbFor(label);
            if (thumb) n.insertBefore(thumb, badge);
            n.classList.add('bb-tick-row');
            n.setAttribute('data-bb-tick', '1');
        }
    }

    /* One settling pass a moment after the picker renders, then stop.
       No live observer: the picker rewrites these summaries itself, and the
       two of us kept overwriting each other until the tab locked up. */
    function watchTicks() {
        tickStyles();
        var picker = document.querySelector('.atlas-custom-variant-picker');
        if (!picker) return;
        var runs = 0;
        (function pass() {
            try { normaliseTicks(picker); } catch (e) {}
            if (++runs < 6) setTimeout(pass, 700);
        }());
        document.addEventListener('click', function () {
            setTimeout(function () {
                try { normaliseTicks(picker); } catch (e) {}
            }, 500);
        }, true);
    }

    var tickTries = 0;
    function startTicks() {
        if (!document.querySelector('.atlas-custom-variant-picker')) {
            if (++tickTries > 20) return;
            return void setTimeout(startTicks, 400);
        }
        watchTicks();
    }

    if (document.readyState !== 'loading') { start(); startTicks(); }
    else document.addEventListener('DOMContentLoaded', function () { start(); startTicks(); });
})();